import {
  xianyuDetail,
  xianyuDetailEdit,
  getXianyuProductAttribute,
  getXianyuRegion,
} from '@/api/prod/center'
import store from '@/store'

// 过滤上传失败或为空的图片
export function _filterInvalidImg(imgsArr) {
  return imgsArr.filter(img => {
    if (!img) {
      return false
    } else if (typeof img === 'object') {
      return false
    } else {
      return true
    }
  })
}
// 处理JSON转换的通用函数
function _handleJSON(data, isStringify) {
  return isStringify ? JSON.stringify(data || []) : JSON.parse(data || '[]')
}

// 处理数组分隔/连接的通用函数
function _handleArray(data, isJoin) {
  if (!data) return []
  return isJoin ? data.join(',') : data.split(',')
}

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
  if (r.skuList?.length) {
    r.skuList = r.skuList.map(item => {
      const skuSpecifications = _handleJSON(item.skuSpecifications, isRequest)
      // const skuSpecifications = isRequest ? JSON.stringify(item.skuSpecifications || []) : JSON.parse(item.skuSpecifications || '[]')
      const _skuid = isRequest ? "" : skuSpecifications.map(sp => sp.valueKey).filter(Boolean).join('-')
      return {
        ...item,
        _skuid,
        skuSpecifications
      }
    })
  }
  // 需要JSON转换的字段
  const transformJsonList = ['detailImages', 'images','specificationNames','specifications','channelPv','templateConfig']
  // 需要数组转换的字段
  const transformArrayList = ['categoryIds', 'shopAddress']
  transformJsonList.forEach(key => {
    r[key] = _handleJSON(r[key], isRequest)
  })
  transformArrayList.forEach(key => {
    r[key] = _handleArray(r[key], isRequest)
  })

  return r

}

// 编辑详情
export function editXianyuInfo(data) {
  return xianyuDetailEdit(_formatGoodsItem(data, true)).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

// 获取详情资料
export function getXianyuDetail(params) {
  return xianyuDetail(params).then(res => {
    if (res.result === 1) {
      return _formatGoodsItem(res.data || {})
    } else {
      return false
    }
  })
}

// 获取类目属性
export function getXyCategoryProps(param) {
  return getXianyuProductAttribute(param).then(res => {
    if (res.result === 1) {
      return res.data || false;
    } else {
      return false;
    }
  })
}

// 咸鱼地址库数据
export function getXianyuRegionData(data) {
  return getXianyuRegion(data).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}


